<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>

export default {
}
</script>
<style lang="scss">
body {
  user-select: auto;
}
#app > .main {
  padding: 20px 40px;
  h1, h2 {
    text-align: center;
  }
  p, div {
    line-height: 2;
  }
  ol {
    list-style-position: inside;

    li {
      font-weight: bold;
      line-height: 2;
    }
  }
}
</style>
